import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import InventoryManagementContainer from 'app/containers/InventoryManagement'

const InventoryManagementPageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.inventory)}</PageTitle>
      <InventoryManagementContainer />
    </>
  )
}
const InventoryManagementPage = memo(InventoryManagementPageCpn, isEqual)

export default InventoryManagementPage
